import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import Receipt from '@material-ui/icons/Receipt';
import EditIcon from '@material-ui/icons/Edit';
import GridContainer from 'components/Grid/GridContainer';
import { Caption, HeadingLBold } from 'components/Typography/Typography';
import CustomButton from 'components/CustomButtons/Button';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/billingAccounts/detailsStyle';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBillingAccountDetailsHeaderProps {
	billingId: string;
	billingName: string;
	openDialog: () => void;
}

const BillingAccountDetailsHeader = ({ billingId, billingName, openDialog }: IBillingAccountDetailsHeaderProps) => {
	const classes = useStyles();
	return (
		<>
			<GridItem lg={2} xs={12}>
				<Card className={classes.iconCard}>
					<CardBody className={classes.center}>
						<Receipt className={classes.icon} />
					</CardBody>
				</Card>
			</GridItem>
			<GridItem lg={10} xs={12}>
				<Card>
					<CardBody className={classes.headerCardBody}>
						<GridContainer>
							<GridItem xs={12} lg={12}>
								<Caption color="secondary-light" disableMargin>
									{translate('active.services.billing.account.name')}
								</Caption>
								<HeadingLBold disableMargin>
									<>
										{billingName}
										<CustomButton justIcon round color="tertiary-light" onClick={openDialog}>
											<EditIcon />
										</CustomButton>
									</>
								</HeadingLBold>
							</GridItem>
						</GridContainer>
					</CardBody>
				</Card>
			</GridItem>
		</>
	);
};

export default BillingAccountDetailsHeader;
